import { motion } from "framer-motion";
import { ArrowUpRight, Heart } from "lucide-react";
import { Reveal, MaskedHeading } from "./Reveal";
import ParallaxImage from "./ParallaxImage";
import { reservarDuo } from "../lib/booking";

const paquetes = [
  {
    nombre: "Escape en Pareja",
    duracion: "150 min · 2 personas",
    img: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?auto=format&fit=crop&w=1000&q=75&crop=entropy&cs=srgb&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjBzcGElMjBtYXNzYWdlfGVufDB8fHx8MTc4NjM5NDkzM3ww&ixlib=rb-4.1.0",
    incluye: "Masaje simultáneo · Facial DUO · Copa de bienvenida",
    desc: "Dos camillas, un mismo instante. Masaje relajante en simultáneo seguido de un facial revitalizante, con un brindis para celebrar el reencuentro.",
  },
  {
    nombre: "Ritual Completo DUO",
    duracion: "210 min · 2 personas",
    img: "https://images.unsplash.com/photo-1576287251622-0eb2f24ae759?auto=format&fit=crop&w=1000&q=75&crop=entropy&cs=srgb&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxjb3VwbGUlMjBzcGElMjBtYXNzYWdlJTIwcmVsYXhhdGlvbiUyMGNhbmRsZXN8ZW58MHx8fHwxNzg2Mzk0OTg3fDA&ixlib=rb-4.1.0",
    incluye: "Masaje · Manicure & barbería · Faciales · Merienda",
    desc: "La experiencia insignia: ella y él viven sus rituales favoritos en paralelo —del masaje a la barbería y el manicure— cerrando con una merienda dulce.",
  },
];

const DuoExperiences = () => {
  return (
    <section
      id="experiencias-duo"
      data-testid="section-duo"
      className="relative bg-[#3a3939] px-6 pt-20 pb-12 md:px-16 md:pt-28 md:pb-16 grain"
    >
      <div className="relative z-10 mx-auto max-w-6xl">
        <div className="flex flex-col items-center text-center">
          <div>
            <MaskedHeading
              className="font-serif-display text-[#faf9f6] text-4xl sm:text-5xl lg:text-7xl leading-none"
              lines={["Experiencias"]}
            />
            <MaskedHeading
              className="font-serif-display italic text-[#cea498] text-4xl sm:text-5xl lg:text-7xl leading-tight"
              lines={["DUO"]}
              delay={0.15}
            />
          </div>
          <Reveal delay={0.24} className="mt-3">
            <p className="font-cormorant text-xl md:text-2xl italic text-[#cea498]">
              Lado a lado, sin prisa
            </p>
          </Reveal>
          <Reveal delay={0.3} className="mt-4 max-w-xl">
            <p className="text-sm md:text-base leading-relaxed text-[#cfc7c0]">
              Donde lo femenino y lo masculino se encuentran. Rituales pensados
              para compartir: parejas, amigas, madre e hija o quien quieras a tu
              lado.
            </p>
          </Reveal>
        </div>

        <div className="mt-8 grid gap-10 md:grid-cols-2">
          {paquetes.map((p, i) => (
            <Reveal key={p.nombre} delay={i * 0.14} className="group">
              <ParallaxImage
                src={p.img}
                alt={p.nombre}
                className="h-96 rounded-3xl"
                overlay="bg-gradient-to-t from-[#1a1a1a]/70 via-[#1a1a1a]/10 to-transparent"
              />
              <div className="mt-7">
                <div className="flex items-baseline justify-between">
                  <h3 className="font-serif-display text-3xl text-[#faf9f6]">
                    {p.nombre}
                  </h3>
                  <span className="label text-[#cea498]">{p.duracion}</span>
                </div>
                <p className="mt-3 font-cormorant text-lg italic text-[#cea498]">
                  {p.incluye}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-[#a49a93]">
                  {p.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-6 flex justify-center">
          <motion.button
            data-testid="reservar-duo-btn"
            onClick={reservarDuo}
            className="group inline-flex items-center gap-3 rounded-full bg-[#cea498] px-10 py-4 text-[#1a1a1a]"
            whileHover={{ backgroundColor: "#f0e4e1" }}
          >
            <span className="label">Reservar DUO</span>
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </motion.button>
        </Reveal>
      </div>
    </section>
  );
};

export default DuoExperiences;
